// 註冊 Inventory 事件監聽器

import { storeToRefs } from 'pinia';
import { useGlobalStore } from '@hc/stores/useGlobalStore';
import { useInventoryStore } from '@hc/stores/useInventoryStore';

export function registerInventoryListeners (echo) {

    const globalStore = useGlobalStore();

    const { global } = storeToRefs(globalStore);

    const prefix = global.value?.broadcast ?? 'dev';

    const inventoryStore = useInventoryStore();

    echo.channel(`${prefix}hc-public`)
        .listen('.inventory.increased', (data) => {
            // console.log('inventory.increased', data);
            inventoryStore.update(data);
        });
};
